import { render } from "./chatPage.vue?vue&type=template&id=0109a5a0"
import script from "./chatPage.vue?vue&type=script&lang=js"
export * from "./chatPage.vue?vue&type=script&lang=js"

import "./chatPage.vue?vue&type=style&index=0&id=0109a5a0&lang=scss"
script.render = render

export default script